import { render, staticRenderFns } from "./EvaluationHeaderMetadata.vue?vue&type=template&id=6f451054&scoped=true&"
import script from "./EvaluationHeaderMetadata.vue?vue&type=script&lang=js&"
export * from "./EvaluationHeaderMetadata.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationHeaderMetadata.vue?vue&type=style&index=0&id=6f451054&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f451054",
  null
  
)

export default component.exports